import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AdminDashboardStats, AdminService} from './admin.service';
import {AppConfigService} from '../shared/app-config.service';

@Component({
  standalone: false,
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
  totalListings = 0;
  totalUsers = 0;
  pendingReports = 0;
  pendingListings = 0;
  totalRevenue = 0;
  loading = true;
  error = '';
  attributesEnabled = true;

  recentActivities: { icon: string; description: string; timestamp: Date }[] = [];

  constructor(private adminService: AdminService,
              private router: Router,
              private appConfigService: AppConfigService) {}

  ngOnInit(): void {
    this.appConfigService.attributesEnabled().subscribe(enabled => {
      this.attributesEnabled = enabled;
    });

    this.adminService.getDashboard().subscribe({
      next: (stats: AdminDashboardStats) => {
        this.totalListings = stats.totalListings;
        this.totalUsers = stats.totalUsers;
        this.pendingReports = stats.pendingReports;
        this.pendingListings = stats.pendingListings;
        this.recentActivities = [
          {
            icon: 'fas fa-clock',
            description: `${stats.pendingListings} listings awaiting moderation`,
            timestamp: new Date()
          },
          {
            icon: 'fas fa-flag',
            description: `${stats.pendingReports} reports pending review`,
            timestamp: new Date()
          },
          {
            icon: 'fas fa-check',
            description: `${stats.publishedListings} listings live on the marketplace`,
            timestamp: new Date()
          }
        ];
        this.loading = false;
      },
      error: () => {
        this.error = 'Unable to load admin dashboard. Sign in as an admin user.';
        this.loading = false;
      }
    });
  }

  moderateListings(): void {
    this.router.navigate(['/admin/listings']);
  }

  manageUsers(): void {
    this.router.navigate(['/admin/users']);
  }

  viewReports(): void {
    this.router.navigate(['/admin/reports']);
  }

  manageAttributes(): void {
    this.router.navigate(['/admin/attributes']);
  }

  managePacks(): void {
    this.router.navigate(['/admin/packs']);
  }
}
